import React from "react";
import { useNavigate } from "react-router-dom";

import { ScenePlaceholder } from "@common/scenePlaceholder";
import { Props } from "./types";
import styles from "./styles.scss";

function NotFoundPage(_: Props) {
  const navigate = useNavigate();
  const goBack = () => navigate(-1);

  return (
    <div className={styles.scenePlaceholder}>
      <ScenePlaceholder goBack={goBack} />
    </div>
  );
}

export { NotFoundPage };
